<div *ngIf="is_loading">
  <div class="flex items-center rounded-xl rounded-tl-none p-[1rem] w-[7rem] ">
      <div role="status">
          <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
              <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
          </svg>
          <span class="sr-only">Loading...</span>
      </div>
  </div>
</div>

<app-alert type="success" 
    message="{{resp_msg || 'O Relatorio Modelo DPR 106 foi gerado com sucesso'}}"
    *ngIf="is_created">
</app-alert>

<app-alert type="error" 
    message="{{ error_msg || 'Nao foi possivel concluir. Verifique todos os campos' }}"
    *ngIf="is_error">
</app-alert>

<app-alert type="warning" 
    message="Alerta: Verifique todos os campos"
    *ngIf="!anexoForForm.valid && !is_loading">
</app-alert>

<div *ngIf="mostrarFormulario">

  <form [formGroup]="anexoForForm" (ngSubmit)="onSubmit()" class="max-w-lg mx-auto">
    <!-- Botões -->
    <div class="flex justify-center mt-6 space-x-3">
      <button type="submit" 
          [disabled]="!anexoForForm.valid || is_loading" 
          class="px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">Submeter</button>
    </div>

    <!-- Parte não repetida -->
    <div class="mb-4 pb-4 border-b">
      <h2 class="text-lg font-bold mb-2">Detalhes Gerais</h2>
      <div class="grid grid-cols-2 gap-5">
        <div class="form-field flex items-center">
          <label for="ano" class="mr-2">Ano:</label>
          <input id="ano" formControlName="ano" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
        </div>
        <div class="form-field flex items-center">
          <label for="mes" class="mr-2">Mês:</label>
          <input id="mes" formControlName="mes" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
        </div>
        <div class="form-field flex items-center">
          <label for="cd_af" class="mr-2">Código AF:</label>
          <input id="cd_af" formControlName="cd_af" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
        </div>
        <div class="form-field flex items-center">
          <label for="nif" class="mr-2">NIF:</label>
          <input id="nif" formControlName="nif" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          
        </div>
        
      </div>
    </div>

    <!-- Parte repetida -->
    <div formArrayName="linhas" class="grid grid-cols-1 gap-6">
      <button type="button" (click)="addLinha()" class="px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">Adicionar Linha</button>
      <div *ngFor="let linha of linhas.controls; let i = index" [formGroupName]="i" class="bg-gray-200 rounded-lg p-6 shadow-md">
        <div class="grid grid-cols-2 gap-4">
          <div class="form-field flex items-center">
            <label for="origem{{ i }}" class="mr-2">Origem:</label>
            <input id="origem{{ i }}" formControlName="origem" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="nif{{ i }}" class="mr-2">NIF:</label>
            <input id="nif{{ i }}" formControlName="nif" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="designacao{{ i }}" class="mr-2">Designação:</label>
            <input id="designacao{{ i }}" formControlName="designacao" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="tp_doc{{ i }}" class="mr-2">Tipo de Documento:</label>
            <input id="tp_doc{{ i }}" formControlName="tp_doc" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="num_doc{{ i }}" class="mr-2">Número do Documento:</label>
            <input id="num_doc{{ i }}" formControlName="num_doc" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="data{{ i }}" class="mr-2">Data:</label>
            <input id="data{{ i }}" formControlName="data" type="date" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="vl_fatura{{ i }}" class="mr-2">Valor da Fatura:</label>
            <input id="vl_fatura{{ i }}" formControlName="vl_fatura" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="vl_base_incid{{ i }}" class="mr-2">Valor Base Incidente:</label>
            <input id="vl_base_incid{{ i }}" formControlName="vl_base_incid" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="tx_iva{{ i }}" class="mr-2">Taxa de IVA:</label>
            <input id="tx_iva{{ i }}" formControlName="tx_iva" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="iva_sup{{ i }}" class="mr-2">IVA Suportado:</label>
            <input id="iva_sup{{ i }}" formControlName="iva_sup" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="direito_ded{{ i }}" class="mr-2">Direito a Dedução:</label>
            <input id="direito_ded{{ i }}" formControlName="direito_ded" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="iva_ded{{ i }}" class="mr-2">IVA Dedutível:</label>
            <input id="iva_ded{{ i }}" formControlName="iva_ded" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="tipologia{{ i }}" class="mr-2">Tipologia:</label>
            <input id="tipologia{{ i }}" formControlName="tipologia" type="text" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="form-field flex items-center">
            <label for="linha_dest_mod{{ i }}" class="mr-2">Linha Dest Mod:</label>
            <input id="linha_dest_mod{{ i }}" formControlName="linha_dest_mod" type="number" class="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:border-blue-500" />
          </div>
          <div class="flex items-center justify-end mt-4 col-span-2">
            <button type="button" (click)="removeLinha(i)" class="text-red-500 hover:text-red-700 focus:outline-none">Remover Linha</button>
          </div>

        </div>
       
      </div>
      
    </div>

  </form>
  
</div>

<div *ngIf="!mostrarFormulario">
  <!-- Se mostrarFormulario for false, exibe a resposta -->
  <!-- <h3>{{ resposta.answer }}</h3> -->
  <!-- Exibir ações disponíveis da resposta, se houver -->
  <div *ngIf="resposta.actions && resposta.actions.length > 0" class="flex">
    <ul class="flex">
      <li *ngFor="let action of resposta.actions">
        <button class="cursor-pointer p-2 bg-[#00527E] rounded-xl font-bold text-white m-2" 
            (click)="executarAcao(action.prompt)">
              {{ action.label }}
        </button>
        </li>
    </ul>
  </div>
</div>
